<template>
    <renderMain />
</template>

<script lang="tsx" setup>
//* 样式
import css from "./style/index.module.less";

//* 组件属性注册
const slots = defineSlots();
const define = defineProps({ subject: { type: String, default: "" } });

//* 渲染函数（主体）
const renderMain = defineComponent({
    render() {
        //* 主题类名
        const className = define.subject ? `${css.container} ${css[define.subject]}` : css.container;
        return (
            <h2 class={`${className} title-3 font-bold`}>
                <div class={css.rhombus}></div>
                <div class={`${css.rhombus} ${css.active}`}></div>
                <span>{slots?.default()}</span>
            </h2>
        );
    },
});
</script>
